/**
 * Internal, extendable class for instatianting components.
 * Each compoment should contain functionality for a single DOM element or selector.
 */
export default class Component {

  /**
   * Create a component
   * @param {object} element - A JS node object containing the component element
   * @param {object} config - Additional options (often selectors) relevant to the component
   * @param {string} name - Name of the component
   * @param {integer} id - ID or index of the component
   */
  constructor(element, config, name, manifest) {
    this.element = element;
    this.started = false;
    this.manifest = manifest;
    this.name = name;

    // Peripheral configuration properties
    this.utils = {};
    this.options = config.options || {};
    this.elements = config.elements || {};

    // Cache jQuery instance of the component element
    this.$element = $(element);

    // Set up a shortcut reference to global components
    Object.keys(this.manifest.utils)
      .forEach((componentName) => {
        this.utils[componentName] = this.manifest
          .utils[componentName];
      });

    // Listeners
    this.eventNamespace = `.${name}`;
  }

  /**
   * Destroy the component, removing the element from the dom and all attached event handlers
   */
  destroy() {
    // remove instance element from DOM
    this.element.parentNode.removeChild(this.element);
  }

  /**
   * Get the top offset of an element relative to a specific DOM node.
   *
   * @param {object} el - DOM node
   * @param {object} context - ID of element relative to which you want the offset
   */
  getOffsetTop(el, context) {
    let offset = 0;

    if (context !== el.getAttribute('id')) {
      offset = el.offsetTop;
      offset += this.getOffsetTop(el.offsetParent, context);
    }

    return offset;
  }
}
